"use client";
import { j as r } from "./jsx-runtime-CJ-St4mQ.mjs";
import * as f from "react";
import { u as p } from "./useRenderElement-B8V3_e8R.mjs";
import { N as v } from "./NavigationMenuItemContext-CXLOapAH.mjs";
import { u as d } from "./useBaseUiId-a-UPSsPQ.mjs";
const s = /* @__PURE__ */ f.forwardRef(function(e, t) {
  const {
    className: n,
    render: o,
    value: i,
    ...m
  } = e, u = d(), l = i ?? u, c = p("div", e, {
    ref: t,
    props: m
  });
  return /* @__PURE__ */ r.jsx(v.Provider, {
    value: l,
    children: c
  });
});
process.env.NODE_ENV !== "production" && (s.displayName = "NavigationMenuItem");
const M = (a) => {
  const { children: e, className: t, role: n = "menuitem", ...o } = a;
  return /* @__PURE__ */ r.jsx(s, { role: n, ...o, className: t, children: e });
};
export {
  M as default
};
